// React
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Hooks
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { useMetaDescription } from "../../hooks/useMetaDescription";

// Components
import ButtonDefault from "../../components/form/ButtonDefault";

//  Styles
import { Container, Header, Main } from "./styles";

// Icons
import { Icon123JusBig, IconEasyJurLegalOps } from "../../components/icons";

// Assets
import UserComplete from '../../assets/images/CreateUserComplete.png'

export interface User {
    userName: string,
}

export default function CreateUserComplete() {
    // Define o título e meta description da página
    useDocumentTitle({ title: "Cadastro Completo" });
    useMetaDescription({ 
        description: "Cadastro concluído com sucesso na EasyJur Legal Ops. Bem-vindo à plataforma de logística jurídica mais eficiente do Brasil." 
    });

    const history = useHistory();
    const location = useLocation<User>();
    const [ user, setUser ] = useState<any>();

    useEffect(() => {

        if (location?.state?.userName !== '') {
            
            setUser(location?.state?.userName);
        }

    }, [location])

    function goToDash() {
        setTimeout(() => {
            history.push('/login')
        }, 3000)
    }

    return (
        <Container>
            <Main>
                <div style={{ width: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <IconEasyJurLegalOps />
                </div>

                <div className="status">
                    
                    <div className="status-title">Olá, <span>{user ? user : 'usuário'}!</span></div>
                    
                    <div className="status-subtitle">
                        Seu cadastro foi realizado com sucesso! <br/>
                        Agora você pode desfrutar do painel configurado <span>especialmente para você</span> !
                    </div>
                    <div className="buttons">
                        <ButtonDefault
                            className="continue"
                            onClick={goToDash}
                        >
                            Vamos Lá
                        </ButtonDefault>
                    </div>
                </div>

                <div className="progress">
                        <div className="progressbar"></div>
                        <div className="bar-title">
                            <span>100%</span> do perfil completo
                        </div>
                    </div>
            </Main>
        </Container>
    )
}